/* global hbspt */
const {KitModule, registerModule} = window;

class Form extends KitModule {
  /**
   * @param {HTMLElement} $element
   */
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.init();
  }

  bindEvents() {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback') {
        if (event.data.eventName === 'onFormReady') {
          this.handleFormReady(event);
        } else if (this.gatedContentUrl && event.data.eventName === 'onFormSubmitted') {
          this.handleDownload();
        }
      }
    });

    if (window.hbspt?.forms) {
      setTimeout(() => {
        const children = [...this.$element.querySelectorAll('.hs-form-field')];
        if (children.length == 1) this.$element.classList.add('has-unique-field');

        for (const child of children) {
          child.querySelector('.hs-input').addEventListener('change', (e) => {
            if (e.currentTarget.value != '') {
              child.classList.add('has-value');
            }
          });
        }
      }, 600);
    }
  }

  /**
   * Fetch gated content and trigger download
   */
  async handleDownload() {
    const response = await fetch(this.gatedContentUrl.toString());
    const blob = await response.blob();
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = this.gatedContentUrl.pathname.split('/').at(-1);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  /**
   * If the URL includes a hash (an element with an anchor link), scroll that
   * element into view after the form successfully loads.
   */
  /* eslint-disable */
  handleFormReady(event) {
    if (this.scrollToHash) {
      const $anchorElement = document.getElementById(this.hash);
      if ($anchorElement) {
        $anchorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }
  /* eslint-enable */


  /**
   * Call the HubSpot create form function
   */
  init() {
    if (!window.hbspt?.forms) {
      // Display fallback content if the HubSpot script failed to load (ex. if
      // the user has content blockers enabled in their browser)
      this.$fallback.setAttribute('aria-hidden', false);
      return;
    }

    if (!this.formId || !this.portalId) {
      /* eslint-disable-next-line no-console */
      console.log('Unexpected form configuration:', {
        formId: this.formId,
        portalId: this.portalId,
        region: this.region,
        instanceId: this.instanceId,
      });
      return;
    }

    hbspt.forms.create({
      formId: this.formId,
      portalId: this.portalId,
      region: this.region,
      instanceId: this.instanceId,
      target: `#hubspotForm__form-${this.instanceId}`,
      css: '',
      onFormReady: () => {
        document.dispatchEvent(new Event('hbsptFormReady'));
      },
      onFormSubmit: (event) => {
        // Execute redirect if it exists
        if (this.redirectUrl) {
          const formData = new FormData(event);
          const queryString = formData ? [...formData.entries()]
            .filter(([key]) => key.startsWith('ftx_'))
            .map(([key, value]) => {
              const updatedKey = key === 'ftx_source' ? 'source' : key;
              const updatedValue = value === 'ftx-retail' ? 'ftx-bahamas-retail' : value === 'ftx' ? 'ftx-bahamas' : value;
              return `${encodeURIComponent(updatedKey)}=${encodeURIComponent(updatedValue)}`;
            })
            .join('&') : '';

          setTimeout(() => {
            window.location.href = this.redirectUrl + '?' + queryString;
          }, 200);
        }

        this.pollingInterval = setInterval(this.checkCalendlyOpen.bind(this), 500);
      },
    });

    if (this.scrollToHash) {
      setTimeout( () => {
        // Cancel automatic scrolling if the form hasn't loaded after two
        // seconds, at which point the user may have begun to scroll aroudn
        // manually.
        this.scrollToHash = false;
      }, 2000);
    }
  }

  setVars() {
    this.formId = this.$element.dataset.formId;
    this.instanceId = this.$element.dataset.formInstanceid;
    this.portalId = this.$element.dataset.portalId;
    this.region = this.$element.dataset.region;
    this.pollingInterval = null;
    this.calendlyOpened = false;
    this.redirectUrl = this.$element.dataset.redirectUrl ?? null;

    if (this.$element.dataset.gatedContent) {
      let gatedContentUrl = atob(this.$element.dataset.gatedContent);
      if (gatedContentUrl.startsWith('//')) {
        gatedContentUrl = 'https:' + gatedContentUrl;
      }
      this.gatedContentUrl = new URL(gatedContentUrl);
    }

    const {hash} = new URL(window.location.href);
    this.hash = hash.replace('#', '');
    this.scrollToHash = this.hash ? true : false;

    this.$modal = this.$element.closest('#modal-form') ?? this.$element.querySelector('#modal-form');
  }

  checkCalendlyOpen() {
    const calendlyOverlay = document.querySelector('.calendly-overlay');

    if (!this.calendlyOpened && calendlyOverlay && calendlyOverlay.style.display !== 'none') {
      this.calendlyOpened = true;

      if (this.$modal) {
        setTimeout(() => {
          window.MicroModal.close(this.$modal.getAttribute('id'));
          document.body.style.overflow = 'hidden';
        }, 1800);
      }
    } else if (this.calendlyOpened && !calendlyOverlay) {
      this.stopPolling();
      document.body.style.overflow = '';
      this.calendlyOpened = false;
    }
  }

  // Stop polling
  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }
}

registerModule('Form', Form);
